// Rental Rate
import currentRentalRate from '@drivesally/sally-fn/lib/rentalRate/libs/currentRentalRate.lib.rentalRate';

// Types
import {amount as amountType} from '@drivesally/sally-fn/lib/types';

// Weights
import mainWeight from '../weights/mainWeight';
import vehiclePayment from '../weights/vehiclePayment';

export const raw = ({
  rental: {rates = [], reduced_deductible = false} = {},
} = {}) =>
  (currentRentalRate(rates, reduced_deductible) * vehiclePayment) / mainWeight;

export default (args) => `$${amountType(raw(args)).format()}`;
